import React, { FC, useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import moment, { Moment } from 'moment'

import { DaysGrid, EventsData } from './types'
import Event from './Event'
import useEventCalendar from './useEventCalendar'
import { CalendarContext } from './EventCalendarContext'
import { useSelector } from 'react-redux'

interface Props {
  i: number
  daysGridLength: number
  item: DaysGrid
  events?: EventsData | undefined
  currentDate: Date
  setCurrentDate: (date: Moment) => void
  colors: number[]
}

const Day: FC<Props> = ({ i, daysGridLength, item, events, currentDate, setCurrentDate,colors }) => {
  const [showNewEventModal, setShowNewEventModal] = useState(false)
  const theme = useTheme()
  const context: CalendarContext = useEventCalendar().context
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'))
  const [title, setTitle] = useState('')
  const [content, setContent] = useState('')
  const locale = useSelector(({theme})=>theme.locale);

  const getWeekDays = () => locale=='en'?[
    'MONDAY',
    'TUESDAY',
    'WEDNESDAY',
    'THURSDAY',
    'FRIDAY',
    'SATURDAY',
    'SUNDAY',
  ]
  :
  [
    'الاثنين',
    'الثلاثاء',
    'الأربعاء',
    'الخميس',
    'الجمعة',
    'السبت',
    'الأحد',
  ]

  const weekDays = getWeekDays()

  const addNewEvent = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (!context?.readonly && title !== '' && content !== '') {
      const newArrayForDataChange: EventsData = [...(context?.data as [])]
      newArrayForDataChange.push({
        title,
        popupContent: (
          <DialogContent>
            <DialogContentText>{content}</DialogContentText>
          </DialogContent>
        ),
        date: item.date,
        color: theme.palette.primary.main,
      })

      setTitle('')
      setContent('')
      setShowNewEventModal((prev) => !prev)
      context?.onDataChange?.(newArrayForDataChange)
    }
  }

  return (
    
    <Grid
      item
      width={`${100 / 7}%`}
      borderTop='none'
      borderRight={() => {
        if (locale!='en'&&i % 7 !== 0) return '1px solid rgb(0, 145, 255, 1)'
      }}
      borderBottom={() => {
        if (!(i > 7 * Math.floor(daysGridLength / 7) - 1))
          return '1px solid rgb(0, 145, 255, 1)'
      }}
      borderLeft={() => {
        if (locale=='en'&&i % 7 !== 0) return '1px solid rgb(0, 145, 255, 1)'
      }}
      key={i}
      textAlign='center'
      height='6rem'
      paddingTop='0.3em'
      overflow='auto'
      onClick={() => { context?.readonly ? null : setCurrentDate(item.date);}
      }
      sx={
        {
          //backgroundColor: currentDate?.toLocaleDateString() == item.date.toLocaleString() ? 'blanchedalmond' : 'transparent',
          ':hover': {
            cursor:'pointer',
            backgroundColor:theme.palette.grey[100],
          }
        }
      }
    >
      {/* <Typography>{events?.length}</Typography> */}
      {/*days  number*/}
      <Typography
        variant='caption'
        fontWeight= 'bold'
        fontSize={16}
        color={theme.palette.getContrastText(
          item?.date && moment().isSame(item?.date, 'day')
            ? theme.palette.primary.main
            : '#FFF'
        )}
        sx={{
          backgroundColor:
            item?.date && moment().isSame(item?.date, 'day')
              ? theme.palette.primary.main
              : 'transparent',
          borderRadius: '50%',
          padding: '0.5em',
          marginBottom: '0.1rem',
          cursor: context?.readonly ? 'default' : 'pointer',
          ':hover': {
            backgroundColor:
              item?.date && moment().isSame(item?.date, 'day')
                ? theme.palette.primary.main
                : theme.palette.grey[100],
          },
        }}
        //onClick={() =>context?.readonly ? null : setShowNewEventModal((prev) => !prev)}
      >
        {item.no}
      </Typography>
      <Grid container rowSpacing={1} sx={{marginTop: '35px', marginRight: '0px'}}>
        {events?.map((e, i) => (
          <Event
            x={colors[i]}
            color={"#FFF"}
            content={e.popupContent}
            i={i}
            key={i}
            title={e.title}
          />
        ))}
      </Grid>
      <Dialog
        fullScreen={fullScreen}
        open={showNewEventModal}
        onClose={() => setShowNewEventModal((prev) => !prev)}
      >
        <DialogTitle padding='0.5rem 1rem !important'>
          Add New Event on {moment(item.date).format('LL')}
        </DialogTitle>
        <Divider light />
        <form onSubmit={addNewEvent}>
          <DialogContent
            sx={{
              padding: '0.5rem 1rem !important',
            }}
          >
            <Stack gap='1em'>
              <TextField
                variant='outlined'
                label='Title'
                type='text'
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
              />
              <TextField
                value={content}
                onChange={(e) => setContent(e.target.value)}
                label='Popup content'
                multiline
                rows={4}
                variant='outlined'
                required
              />
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setShowNewEventModal((prev) => !prev)}>
              Cancel
            </Button>
            <Button type='submit'>Add</Button>
          </DialogActions>
        </form>
      </Dialog>
    </Grid>
  )
}

export default Day
